import { Box, FormControl, InputLabel, ListItemText, MenuItem, Select, SelectChangeEvent, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { setCurrentReportTable } from './Slice/reportSlice';

import { ReportTableType } from 'components/ReportsTables/ReportTableType';
import { useAppDispatch, useAppSelector } from 'slices';
import '../Traps/TablesTitle/TablesTitle.scss';
import MultiCatchMouseTrapIcon from 'components/Icons/MultiCatchMouseTrapIcon';
import SmartRodentBaitModuleIcon from 'components/Icons/SmartRodentBaitModuleIcon';
import SnapTrapMouseIcon from 'components/Icons/SnapTrapMouseIcon';
import SnapTrapRatIcon from 'components/Icons/SnapTrapRatIcon';

const CustomSelect = styled(Select)({
  '&.MuiInputBase-root': {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    borderColor: 'red',
  },
  '& .MuiSelect-select': {
    padding: '10px 12px',
    paddingRight: '24px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: '1px solid #E0E0E0',
  },
});

const ReportsHeader: React.FC = () => {
  const { t } = useTranslation();
  const { currentReportTable } = useAppSelector(state => state.Reports);
  const tables: string[] = Object.values(ReportTableType);

  const dispatch = useAppDispatch();

  const handleChange = (event: SelectChangeEvent<unknown>) => {
    dispatch(setCurrentReportTable(event.target.value as ReportTableType));
  };

  const imageForCurrentTable = (currentReportTable: ReportTableType) => {
    // Відповідно до поточної таблиці виводимо відповідну іконку девайсу
    switch (currentReportTable) {
      case ReportTableType.MCTMonitoring:
        return <MultiCatchMouseTrapIcon width={40} height={40} />;
      case ReportTableType.SRBMMonitoring:
        return <SmartRodentBaitModuleIcon width={40} height={40} />;
      case ReportTableType.SRSTMonitoring:
        return <SnapTrapRatIcon width={40} height={40} />;
      case ReportTableType.SMSTMonitoring:
        return <SnapTrapMouseIcon width={35} height={35} />;
    }
  };

  return (
    <div className="table-title bg-white border-bottom pb-2">
      <div className="title">
        <div className="mx-2">{imageForCurrentTable(currentReportTable)}</div>
        <div className="d-flex align-items-center h4 mb-0 fw-bold gap-2 ">{currentReportTable}</div>
      </div>
      <div className="buttons">
        <FormControl sx={{ minWidth: 120 }}>
          <InputLabel
            id="demo-simple-select-standard-label"
            sx={{ fontFamily: 'Poppins, sans-serif', fontSize: '0.925rem', caretColor: 'red' }}
          >
            {t('VisitReportsPDF.header.currentSmartDevice')}
          </InputLabel>
          <CustomSelect
            value={currentReportTable}
            onChange={handleChange}
            id="demo-simple-select-filled"
            label={t('VisitReportsPDF.header.currentTrapsTable')}
            sx={{
              width: 350,
              fontFamily: 'Poppins, sans-serif',
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'var(--vz-purple)',
              },

              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: 'var(--vz-purple)',
              },
            }}
            renderValue={selected => {
              if (typeof selected !== 'string') return null;
              return (
                <Box display="flex" alignItems="center" justifyContent="start">
                  <ListItemText primary={selected} />
                </Box>
              );
            }}
          >
            {tables.map(tableName => (
              <MenuItem
                key={tableName}
                value={tableName}
                sx={{
                  fontFamily: 'Poppins, sans-serif',
                  cursor: 'pointer',
                }}
                className="d-flex align-items-center gap-2"
              >
                {imageForCurrentTable(tableName as ReportTableType)}
                {tableName}
              </MenuItem>
            ))}
          </CustomSelect>
        </FormControl>
      </div>
    </div>
  );
};

export default ReportsHeader;
